// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  height: 100vh;
}

.eu-council-game-container {
  position: absolute;
  top: 0;
  z-index: 1;
  background-color: #183872;
}

.container {
  position: relative;
  top: 0;
  z-index: 1;
  height: 100%;
}
.container .top-row {
  margin-top: 1.333rem;
  margin-bottom: 2.292rem;
}
.container .top-row .title {
  font-size: 1rem;
  line-height: 1.375rem;
  font-weight: bold;
  color: var(--color-white);
  text-shadow: 0 4px 0 rgba(0, 0, 0, 0.24);
}
.container .top-row .setting {
  position: absolute;
  right: 1rem;
  top: 0;
}
.container .top-row .setting .setting-button {
  width: 2.667rem;
  height: 2.667rem;
}
.container .box {
  width: 29rem;
  position: relative;
  display: inline-block;
  padding: 1.875rem 1.75rem 1.3rem 1.75rem;
  text-align: center;
  color: var(--color-white);
  margin-left: 5.333rem;
  border-radius: 11px;
  background: var(--color-white);
  box-shadow: rgba(0, 0, 0, 0.16) 2px 3px 0 1px, rgb(209, 213, 219) 0 0 0 1px inset;
}
.container .box:before {
  content: "";
  position: absolute;
  border-left: 2px solid var(--color-white);
  border-bottom: 2px solid var(--color-white);
  left: 28.2rem;
  transform: rotateZ(45deg);
  width: 1rem;
  height: 1rem;
  top: 4rem;
  background: var(--color-white);
  border-top: 0;
  border-right: 0;
}
.container .box .main-title {
  color: var(--color-primary-blue);
  letter-spacing: 0;
  line-height: 1.333rem;
  font-size: 1.167rem;
  font-weight: bold;
  margin-bottom: 1.125rem;
}
.container .box .subtitle1 {
  color: var(--color-primary-blue);
  letter-spacing: 0;
  line-height: 1.333rem;
  font-size: 0.833rem;
  margin-bottom: 1rem;
}
.container .box .subtitle2 {
  color: var(--color-primary-blue);
  letter-spacing: 0;
  line-height: 1.333rem;
  font-size: 0.833rem;
}
.container .box .page-2-subtitle {
  color: var(--color-primary-blue);
  letter-spacing: 0;
  line-height: 1.333rem;
  font-size: 0.833rem;
}
.container .box .avatars {
  height: 7rem;
  width: auto;
}
.container .box .handshake {
  height: 4rem;
  width: auto;
}
.container .box .page-3-icons {
  margin-top: 1rem;
}
.container .box .page-3-icons .left-col {
  display: flex;
  justify-content: flex-end;
}
.container .box .page-3-icons .middle-col {
  margin-bottom: 1rem;
}
.container .box .page-3-icons .middle-col span {
  color: var(--color-primary-blue);
}
.container .box .page-3-icons .right-col {
  display: flex;
  justify-content: flex-start;
}
.container .box .page-3-icons .icon {
  height: 4.5rem;
  width: 4.5rem;
}
.container .box .btn-group {
  margin-top: 1rem;
}
.container .box .btn-group .buttonContinue {
  display: flex;
  justify-content: flex-end;
}
.container .box .btn-group .buttonContinue .button {
  --background: var(--color-primary-blue);
  font-size: 0.875rem;
  line-height: 1.167rem;
  min-width: 6.958rem;
  height: 2rem;
  min-height: 2rem;
  --min-height: 2rem;
}
.container .box .btn-group .buttonSkip {
  display: flex;
  justify-content: flex-start;
}
.container .box .btn-group .buttonSkip .button {
  --background: var(--color-white);
  --border-color: var(--color-primary-blue);
  color: var(--color-primary-blue);
  font-size: 0.833rem;
  line-height: 1.125rem;
  min-width: 5.667rem;
  height: 2rem;
  min-height: 2rem;
  --min-height: 2rem;
}
.container .box .btn-group .buttonNext {
  display: flex;
  justify-content: center;
}
.container .box .btn-group .buttonNext .button {
  --background: var(--color-primary-blue);
  font-size: 0.875rem;
  line-height: 1.167rem;
  min-width: 6.958rem;
  height: 2rem;
  min-height: 2rem;
  --min-height: 2rem;
}
.container .council {
  display: grid;
  position: absolute;
  left: 39.7rem;
  top: 21.5rem;
  margin-top: 0.3rem;
  padding: 0.6rem;
  color: var(--color-primary-blue);
  font-size: 0.917rem;
  text-align: center;
  line-height: 1rem;
  font-weight: bold;
}

.text-title2 {
  color: #003399;
  letter-spacing: 0;
  line-height: 1.333rem;
  text-align: center;
  font-size: 1.167;
  margin-bottom: 0.8rem;
}

.text-title3 {
  color: #003399;
  letter-spacing: 0;
  line-height: 1.333rem;
  text-align: center;
  font-size: 1.167;
  margin-bottom: 0.8rem;
}

.text {
  margin-top: 0.5rem;
  padding-top: 0.6rem;
  padding: 0.6rem;
  font-size: 0.833rem;
  color: #003399;
  text-align: center;
  line-height: 1.333rem;
}

.text4 {
  padding-top: 0.2rem;
  font-size: 0.833rem;
  color: #003399;
  text-align: center;
  line-height: 1.333rem;
}

.text2 {
  margin-top: 0.2rem;
  padding: 0.1rem;
  font-size: 0.833rem;
  color: #003399;
  text-align: center;
  line-height: 1.333rem;
}

.text3 {
  margin-top: 0.5rem;
  padding: 0.1rem;
  font-size: 0.833rem;
  color: #003399;
  text-align: center;
  line-height: 1.333rem;
}

.btn-group .button1 {
  background-color: #003399;
  border: none;
  color: white;
  padding: 0.7rem 1.5rem;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 0.9rem;
  cursor: pointer;
  margin-top: 0.5rem;
}

.button-end {
  border-end-end-radius: 3rem;
  border-start-end-radius: 3rem;
}

.button-start {
  border-end-start-radius: 3rem;
  border-start-start-radius: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/app/game/voting/voting-modal/voting-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;AACF;AACE;EACE,oBAAA;EACA,uBAAA;AACJ;AACI;EACE,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,wCAAA;AACN;AAEI;EACE,kBAAA;EACA,WAAA;EACA,MAAA;AAAN;AAEM;EACE,eAAA;EACA,gBAAA;AAAR;AAKE;EACE,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,wCAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,8BAAA;EACA,iFAAA;AAHJ;AAMI;EACE,WAAA;EACA,kBAAA;EACA,yCAAA;EACA,2CAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,eAAA;AAJN;AAOI;EACE,gCAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;AALN;AAQI;EACE,gCAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;AANN;AASI;EACE,gCAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;AAPN;AAUI;EACE,gCAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;AARN;AAWI;EACE,YAAA;EACA,WAAA;AATN;AAaI;EACE,YAAA;EACA,WAAA;AAXN;AAeI;EACE,gBAAA;AAbN;AAeM;EACE,aAAA;EACA,yBAAA;AAbR;AAgBM;EACE,mBAAA;AAdR;AAgBQ;EACE,gCAAA;AAdV;AAkBM;EACE,aAAA;EACA,2BAAA;AAhBR;AAmBM;EACE,cAAA;EACA,aAAA;AAjBR;AAqBI;EACE,gBAAA;AAnBN;AAqBM;EACE,aAAA;EACA,yBAAA;AAnBR;AAqBQ;EACE,uCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAnBV;AAuBM;EACE,aAAA;EACA,2BAAA;AArBR;AAuBQ;EACE,gCAAA;EACA,yCAAA;EACA,gCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AArBV;AAyBM;EACE,aAAA;EACA,uBAAA;AAvBR;AAyBQ;EACE,uCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAvBV;AA6BE;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AA3BJ;;AA+BA;EACE,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AA5BF;;AA+BA;EACE,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AA5BF;;AA+BA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AA5BF;;AA+BA;EACE,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AA5BF;;AA+BA;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AA5BF;;AA+BA;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AA5BF;;AA+BA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EAEA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AA7BF;;AAgCA;EACE,2BAAA;EACA,6BAAA;AA7BF;;AAgCA;EACE,6BAAA;EACA,+BAAA;AA7BF","sourcesContent":["ion-content {\n  height: 100vh;\n}\n\n.eu-council-game-container {\n  position: absolute;\n  top: 0;\n  z-index: 1;\n  background-color: #183872;\n}\n\n.container {\n  position: relative;\n  top: 0;\n  z-index: 1;\n  height: 100%;\n\n  .top-row {\n    margin-top: 1.333rem;\n    margin-bottom: 2.292rem;\n\n    .title {\n      font-size: 1rem;\n      line-height: 1.375rem;\n      font-weight: bold;\n      color: var(--color-white);\n      text-shadow: 0 4px 0 rgba(0, 0, 0, 0.24);\n    }\n\n    .setting {\n      position: absolute;\n      right: 1rem;\n      top: 0;\n\n      .setting-button {\n        width: 2.667rem;\n        height: 2.667rem;\n      }\n    }\n  }\n\n  .box {\n    width: 29rem;\n    position: relative;\n    display: inline-block;\n    padding: 1.875rem 1.75rem 1.3rem 1.75rem;\n    text-align: center;\n    color: var(--color-white);\n    margin-left: 5.333rem;\n    border-radius: 11px;\n    background: var(--color-white);\n    box-shadow: rgba(0, 0, 0, 16%) 2px 3px 0 1px,\n    rgb(209, 213, 219) 0 0 0 1px inset;\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      border-left: 2px solid var(--color-white);\n      border-bottom: 2px solid var(--color-white);\n      left: calc(28.7rem - 0.5rem);\n      transform: rotateZ(45deg);\n      width: 1rem;\n      height: 1rem;\n      top: 4rem;\n      background: var(--color-white);\n      border-top: 0;\n      border-right: 0;\n    }\n\n    .main-title {\n      color: var(--color-primary-blue);\n      letter-spacing: 0;\n      line-height: 1.333rem;\n      font-size: 1.167rem;\n      font-weight: bold;\n      margin-bottom: 1.125rem;\n    }\n\n    .subtitle1 {\n      color: var(--color-primary-blue);\n      letter-spacing: 0;\n      line-height: 1.333rem;\n      font-size: 0.833rem;\n      margin-bottom: 1rem;\n    }\n\n    .subtitle2 {\n      color: var(--color-primary-blue);\n      letter-spacing: 0;\n      line-height: 1.333rem;\n      font-size: 0.833rem;\n    }\n\n    .page-2-subtitle {\n      color: var(--color-primary-blue);\n      letter-spacing: 0;\n      line-height: 1.333rem;\n      font-size: 0.833rem;\n    }\n\n    .avatars {\n      height: 7rem;\n      width: auto;\n      //margin-right: 0.563rem;\n    }\n\n    .handshake {\n      height: 4rem;\n      width: auto;\n      //margin-right: 0.563rem;\n    }\n\n    .page-3-icons {\n      margin-top: 1rem;\n\n      .left-col {\n        display: flex;\n        justify-content: flex-end;\n      }\n\n      .middle-col {\n        margin-bottom: 1rem;\n\n        span {\n          color: var(--color-primary-blue);\n        }\n      }\n\n      .right-col {\n        display: flex;\n        justify-content: flex-start;\n      }\n\n      .icon {\n        height: 4.5rem;\n        width: 4.5rem;\n      }\n    }\n\n    .btn-group {\n      margin-top: 1rem;\n\n      .buttonContinue {\n        display: flex;\n        justify-content: flex-end;\n\n        .button {\n          --background: var(--color-primary-blue);\n          font-size: 0.875rem;\n          line-height: 1.167rem;\n          min-width: 6.958rem;\n          height: 2rem;\n          min-height: 2rem;\n          --min-height: 2rem;\n        }\n      }\n\n      .buttonSkip {\n        display: flex;\n        justify-content: flex-start;\n\n        .button {\n          --background: var(--color-white);\n          --border-color: var(--color-primary-blue);\n          color: var(--color-primary-blue);\n          font-size: 0.833rem;\n          line-height: 1.125rem;\n          min-width: 5.667rem;\n          height: 2rem;\n          min-height: 2rem;\n          --min-height: 2rem;\n        }\n      }\n\n      .buttonNext {\n        display: flex;\n        justify-content: center;\n\n        .button {\n          --background: var(--color-primary-blue);\n          font-size: 0.875rem;\n          line-height: 1.167rem;\n          min-width: 6.958rem;\n          height: 2rem;\n          min-height: 2rem;\n          --min-height: 2rem;\n        }\n      }\n    }\n  }\n\n  .council {\n    display: grid;\n    position: absolute;\n    left: 39.7rem;\n    top: 21.5rem;\n    margin-top: 0.3rem;\n    padding: 0.6rem;\n    color: var(--color-primary-blue);\n    font-size: 0.917rem;\n    text-align: center;\n    line-height: 1rem;\n    font-weight: bold;\n  }\n}\n\n.text-title2 {\n  color: #003399;\n  letter-spacing: 0;\n  line-height: 1.333rem;\n  text-align: center;\n  font-size: 1.167;\n  margin-bottom: 0.8rem;\n}\n\n.text-title3 {\n  color: #003399;\n  letter-spacing: 0;\n  line-height: 1.333rem;\n  text-align: center;\n  font-size: 1.167;\n  margin-bottom: 0.8rem;\n}\n\n.text {\n  margin-top: 0.5rem;\n  padding-top: 0.6rem;\n  padding: 0.6rem;\n  font-size: 0.833rem;\n  color: #003399;\n  text-align: center;\n  line-height: 1.333rem;\n}\n\n.text4 {\n  padding-top: 0.2rem;\n  font-size: 0.833rem;\n  color: #003399;\n  text-align: center;\n  line-height: 1.333rem;\n}\n\n.text2 {\n  margin-top: 0.2rem;\n  padding: 0.1rem;\n  font-size: 0.833rem;\n  color: #003399;\n  text-align: center;\n  line-height: 1.333rem;\n}\n\n.text3 {\n  margin-top: 0.5rem;\n  padding: 0.1rem;\n  font-size: 0.833rem;\n  color: #003399;\n  text-align: center;\n  line-height: 1.333rem;\n}\n\n.btn-group .button1 {\n  background-color: #003399;\n  border: none;\n  color: white;\n  padding: 0.7rem 1.5rem;\n  // margin-left: 1.5rem;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 0.9rem;\n  cursor: pointer;\n  margin-top: 0.5rem;\n}\n\n.button-end {\n  border-end-end-radius: 3rem;\n  border-start-end-radius: 3rem;\n}\n\n.button-start {\n  border-end-start-radius: 3rem;\n  border-start-start-radius: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
